import { render, staticRenderFns } from "./ComunicazioniRecenti.vue?vue&type=template&id=1247b3f2&scoped=true&"
import script from "./ComunicazioniRecenti.vue?vue&type=script&lang=js&"
export * from "./ComunicazioniRecenti.vue?vue&type=script&lang=js&"
import style0 from "./ComunicazioniRecenti.vue?vue&type=style&index=0&id=1247b3f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1247b3f2",
  null
  
)

export default component.exports